import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Albaran/generarExcelListadoAlbaran`, method: 'POST', body: values, token: token})
}
